import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { ProductDataSource } from '../../Model/dataProcess/productDataSource';
import { Brand } from '../../Model/Dto/Brand/Brand';
import { DataSourceMapping } from '../../Model/Catalog/DataSourceMapping';
import {Supplier} from "../../Model/Catalog/Supplier";

@Injectable()
export class DataSourcesService {

  private readonly apiUrl = 'api/DataSources';

  constructor(private http: HttpClient) {}

  public get(id: string, customerId: string): Promise<ProductDataSource> {
    const url = `${this.apiUrl}/get`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<ProductDataSource>(url, options));
  }

  public getAll(customerId: string): Promise<ProductDataSource[]> {
    const url = `${this.apiUrl}/getAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<ProductDataSource[]>(url, options));
  }

  public create(model: ProductDataSource, customerId: string): Promise<ProductDataSource> {
    const url = `${this.apiUrl}/create`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<ProductDataSource>(url, model, options));
  }

  public update(model: ProductDataSource, customerId: string): Promise<ProductDataSource> {
    const url = `${this.apiUrl}/update`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post<ProductDataSource>(url, model, options));
  }

  public delete(id: string, customerId: string): Promise<ProductDataSource> {
    const url = `${this.apiUrl}/delete`;
    const params = new HttpParams().append('id', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.delete<ProductDataSource>(url, options));
  }

  public startApplyChangedMappingsMakro(changedMappings: DataSourceMapping[], customerId: string, catalogId: string): Promise<object> {
    const url = `${this.apiUrl}/startApplyChangedMappingsMakro`;
    const params = new HttpParams().append('customerId', customerId).append('CatalogId', catalogId);
    const options = { params };
    return lastValueFrom(this.http.post(url, changedMappings, options));
  }

  public getRelatedBrands(id: string, customerId: string): Promise<Brand[]> {
    const url = `${this.apiUrl}/getBrandsOfDataSource`;
    const params = new HttpParams().append('dataSourceId', id).append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.get<Brand[]>(url, options));
  }

  public getDataSourceByName(name: string, customerId: string): Promise<ProductDataSource> {
    const url = `${this.apiUrl}/getDataSourceByName`;
    const params = new HttpParams().append('name', name).append('customerId', customerId);
    const options = {params};
    return lastValueFrom(this.http.get<ProductDataSource>(url, options));
  }

  public getAllCatalogManufacturerNames(catalogId: string, customerId: string): Promise<Array<{ manufacturerName: string }>> {
    const url = `${this.apiUrl}/GetAllCatalogManufacturerNames`;
    const params = new HttpParams().append('customerId', customerId).append('catalogId', catalogId);
    const options = { params };
    return lastValueFrom(this.http.get<Array<{ manufacturerName: string }>>(url, options));
  }

  public startExcelExport(customerId: string): Promise<object> {
    const url = `${this.apiUrl}/startExcelExport`;
    const params = new HttpParams().append('customerId', customerId);
    const options = { params };
    return lastValueFrom(this.http.post(url, undefined, options));
  }

}
